import { render, staticRenderFns } from "./itemFormFields.vue?vue&type=template&id=4af1e3b2&"
import script from "./itemFormFields.vue?vue&type=script&lang=js&"
export * from "./itemFormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports